import { Map } from 'immutable';
import { makeAutoObservable } from 'mobx';
import { DateTime } from 'src_common/utils/time/time';
import React from 'react';
import { request as queryAudit } from 'src/modules/audits/actions/query';
import { AutoWeakMap } from 'src_common/common/mobx-utils/AutoWeakMap';
import { Common } from 'src/AppState/Common';

export class CustomerTabState {
    public parameters: unknown = Map();
    public data: unknown = Map();
    public history: unknown = Map();
    public showAllAudits = false;

    private constructor(private readonly userId: number) {
        makeAutoObservable(this);
    }

    public static get = AutoWeakMap.create((_common: Common, userId: number): CustomerTabState => {
        return new CustomerTabState(userId);
    });

    private get getPlayBreakDate(): string | null {
        return $appState.models.getUserModel(this.userId).basicData.data?.playBreakExpiry ?? null;
    }

    private get isPlayBreakExpired(): boolean | undefined {
        let out;
        const playBreakDate = this.getPlayBreakDate;

        if (playBreakDate !== null) {
            out = true;
        }

        const playBreakDateFormat = DateTime.from(playBreakDate ?? undefined);
        if (playBreakDate !== null && playBreakDateFormat !== null && DateTime.current().isAfter(playBreakDateFormat)) {
            out = false;
        }

        return out;
    }

    public get isActiveStatus(): boolean {
        const redStatus = ['blocked', 'suspended', 'pending', 'closed'];
        const customerData = $appState.models.getUserModel(this.userId).basicData.data;

        if (redStatus.some((element) => element === customerData?.status) || this.isPlayBreakExpired === true) {
            return false;
        }
        return true;
    }

    public toggleTraderChat = (tab: string | number | null): void => {
        if (tab === null) {
            $appState.routerBackoffice.removeParamInNamespace('customers', 'chat');
        } else {
            $appState.routerBackoffice.setParamInNamespace('customers', 'chat', 'chat');
        }
    };

    public toggleBetslip = (tab: string | number | null): void => {
        if (tab === null) {
            $appState.routerBackoffice.removeParamInNamespace('customers', 'betslip');
        } else {
            $appState.routerBackoffice.setParamInNamespace('customers', 'betslip', tab);
        }
    };

    public onQueryAudits = (id: string, topic: string, tag: string | Array<string>, filterName: string | null) => {
        return (e: React.MouseEvent): void => {
            const filterTab = $appState.customerTabState.filterTab;

            this.showAllAudits = false;
            e.preventDefault();
            const tagNames = [
                'transactionType-deposit',
                'transactionType-withdrawal',
                'transactionType-manualAdjustment',
            ];
            const tagsArray: Array<string | undefined | null> =
                Array.isArray(tag) === true ? tag.filter((a) => !tagNames.includes(a) || a === filterName) : [tag];

            if (filterName !== null && filterTab !== undefined) {
                tagsArray.push(filterTab);
            }

            const tagsArrayDedup = Array.from(new Set(tagsArray));
            const tagsToQuery = tagsArrayDedup.filter((tag) => tag !== undefined && tag !== null && tag !== '');

            $appState.reduxAction.dispatchAction(
                queryAudit(
                    id,
                    { topics: [topic], tags: tagsToQuery, allAudits: false, filterName: filterName },
                    filterName
                )
            );
        };
    };

    public onShowAll = (id: string, topic: string, tag: Array<string | undefined | null>) => {
        return (e: React.MouseEvent): void => {
            this.showAllAudits = true;
            const tagsToQuery = tag.filter(
                (tag: string | undefined | null) => tag !== undefined && tag !== null && tag !== ''
            );
            e.preventDefault();
            $appState.reduxAction.dispatchAction(
                queryAudit(id, { topics: [topic], tags: tagsToQuery, allAudits: true }, '')
            );
        };
    };

    public showBetslip(tab: string): void {
        $appState.routerBackoffice.setParamInNamespace('customers', 'betslip', tab);
    }
}
